window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

var Bugsnag = require("@bugsnag/js");
var BugsnagPluginVue = require("@bugsnag/plugin-vue");

var bugSnagApiKey = process.env.MIX_BUGSNAG_API_KEY_FRONTEND;

try {
    window.$ = window.jQuery = require("jquery");
    require("jquery-ui/ui/widgets/autocomplete.js");
    require("bootstrap-sass");
} catch (e) {}

window.Vue = require("vue");

// ADDING BUGSNAG AFTER VUE INSTANTIATION

if (bugSnagApiKey) {
    Bugsnag.start({
        apiKey: bugSnagApiKey,
        releaseStage: process.env.MIX_BUGSNAG_RELEASE_STAGE || "local",
        enabledReleaseStages: ["staging", "prod", "local"],
        plugins: [new BugsnagPluginVue()],
    });

    Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);
}

Vue.config.errorHandler = function (err, vm, info) {
  Bugsnag.notify(err)
}

Vue.use(require("vue-resource"));
require("jquery-datetimepicker");
require("select2");
require("malihu-custom-scrollbar-plugin");
require("velocity-animate");
require("velocity-animate/velocity.ui.js");
window.validator = require("jquery-validation");
window.validate = require("./validate");
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
window.toastr = require("toastr");
import VueProgressBar from "vue-progressbar";
window.Ladda = require("ladda");
require("spin.js");
// require("vue-croppie");
const options = {
    color: "#fe9526",
    failedColor: "#fd3d39",
    thickness: "2px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
};
import VCalendar from "v-calendar";
Vue.use(VCalendar);

Vue.use(VueProgressBar, options);
import FullCalendar from "vue-full-calendar";
Vue.use(FullCalendar);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

Vue.http.headers.common["X-CSRF-TOKEN"] = $('meta[name="csrf-token"]').attr(
    "content"
);
$(".keydisable")
    .attr("readOnly", "true")
    .css({
        background: "white",
        color: "#232531",
    });
$(document).ready(function() {
    if ($("#navValue").length) {
        var vanClass = $("#navValue").val();
        $("#stacked-menu")
            .find(".leftNav")
            .removeClass("active");
        $("#stacked-menu")
            .find("." + vanClass)
            .addClass("active");
    }
    if ($("#navValue").length) {
        var vanClass = $("#navValue").val();
        if ($("#searchSelect ul li a." + vanClass).length) {
            $("#searchSelect ul li a." + vanClass).trigger("click");
            $("#selectedSearchSection").text(
                $("#searchSelect ul li a." + vanClass).text()
            );
        }
    }
    $(".date-icon").on("click", function() {
        $(this)
            .prev(".form-control")
            .focus();
    });
    //    $("#topFilter input").keypress(function() {
    //        $(this).parent("#topFilter").removeClass('open');
    //    });
    var $content, $modal, $apnData, $modalCon, $id;
    $content = $(".min");

    $(".mdlFire").click(function(e) {
        $id = $(this).data("target");
        $($id).modal("show");
        var $modalId = $id;
        //            console.log($($modalId).find("i"));
        //            $('.modalMinimize').find("i").removeClass('ion-ios-browsers-outline').addClass('ion-ios-minus-empty');
        $(".modToggle").text("remove");
    });

    $(".modalMinimize").on("click", function() {
        $modalCon = $(this)
            .closest(".tq-modal")
            .attr("id");
        $apnData = $(this).closest(".tq-modal");
        $modal = "#" + $modalCon;
        $($modal).toggleClass("min");

        if ($($modal).hasClass("min")) {
            $(".minmaxCon").append($apnData);
            //                $(this).find("i").removeClass('ion-ios-minus-empty').addClass('ion-ios-browsers-outline');
            $(this)
                .find(".modToggle")
                .text("launch");
        } else {
            $(".main-body").append($apnData);
            //                $(this).find("i").removeClass('ion-ios-browsers-outline').addClass('ion-ios-minus-empty');
            $(this)
                .find(".modToggle")
                .text("remove");
        }
    });
    $("button[data-dismiss='modal']").click(function() {
        $apnData = $(this).closest(".tq-modal");
        $(this)
            .closest(".tq-modal")
            .removeClass("min");
        //            $(this).find("i").removeClass('ion-ios-browsers-outline').addClass('ion-ios-minus-empty');
        $(this)
            .find(".modToggle")
            .text("remove");
    });
    toastr.options = {
        closeButton: true,
        positionClass: "toast-top-center",
        timeOut: "10000",
        showDuration: "300",
        hideDuration: "300",
        tapToDismiss: false,
        preventDuplicates: true,
    };
    $(".toast-sample").click(function() {
        toastr.options = {
            closeButton: true,
            positionClass: "toast-top-center",
            timeOut: "0",
            extendedTimeOut: "0",
            hideDuration: "1000",
            tapToDismiss: true,
        };
        Command: toastr["error"](
            "Success toastr Success toastr Success toastr Success toastr"
        );
    });
    //$('.datetimepicker').datepicker();
    $(".dropdown-menu li a").click(function() {
        var selectedText = $(this).text();
        $(this)
            .parents(".btn-group,.input-group")
            .find(".selection")
            .text(selectedText);
        //        $(".topFilter input").attr("placeholder", "Select" +" "+ selectedText);
    });
    jQuery.datetimepicker.setLocale("en");
    $(".datepicker").datetimepicker({
        timepicker: false,
        format: "d/m/Y",
        scrollInput: false,
    });
    $(".timepicker").datetimepicker({
        datepicker: false,
        format: "H:i",
        hours12: true,
        scrollInput: false,
    });
    $(".datepicker")
        .attr("readOnly", "true")
        .css({
            background: "white",
            color: "#232531",
        })
        .datetimepicker({
            scrollInput: false,
            format: "d/m/Y",
        });
    $(".select2-test").select2({
        theme: "bootstrap",
        minimumResultsForSearch: Infinity,
    });
    $(".select-select2").select2({
        theme: "bootstrap",
        minimumResultsForSearch: Infinity,
    });
    // animation to the modal
    $(".modal").each(function() {
        $(this).on("show.bs.modal", function(e) {
            var open = $(this).attr("data-easein");
            $(".modal-dialog").velocity("transition." + open, 500);
        });
        $(this).on("shown.bs.modal", function() {
            $(".modal-backdrop.in").hide();
        });
    });

    $(".tqScrollbar").mCustomScrollbar({
        theme: "minimal-dark",
        scrollInertia: "100",
    });
    $(".closable").on("click", function() {
        var effect = $(this).data("effect");
        $(this)
            .closest(".closable-div")
            [effect]();
    });
    $(".forgotPass").click(function(e) {
        e.preventDefault();
        $(".userSignUp").hide();
        $(".userResetMail")
            .removeClass("hide")
            .show();
        return false;
    });
    $(".signLink").click(function(e) {
        $(".userSignUp").show();
        $(".userResetMail")
            .removeClass("hide")
            .hide();
        return false;
    });

    //faq-page
    $(".faq-menu-item > a").click(function() {
        $(".faq-menu-item").removeClass("active");
        $(this)
            .parent("li")
            .addClass("active");
        $(".faq-menu-item .collapse-menu").removeClass("in");
    });
    $(".collapse-menu li a").click(function() {
        $(".collapse-menu li").removeClass("active");
    });
});

//show full text when text ellipsis is there
$(document).on("mouseenter", ".fullTextTooltip", function() {
    var $this = $(this);
    if (this.offsetWidth < this.scrollWidth) {
        $this.tooltip({
            placement: "bottom",
        });
        $this.tooltip("show");
    } else {
        $this.tooltip("destroy");
    }
});

//recent activity section for profile pages
$(document).ready(function() {
    $(window).scroll(function() {
        // check if scroll event happened
        activityscroll();
    });

    function activityscroll() {
        if ($(document).scrollTop() > 60) {
            // check if user scrolled more than 60 from top of the browser window
            $(".recentActivitySection").addClass("activityFixed");
        } else {
            $(".recentActivitySection").removeClass("activityFixed");
        }
    }
    // autocomplete

    $(function() {
        var elasticHeaderTop = $("#headerElasticTop");
        if (elasticHeaderTop && elasticHeaderTop.length) {
            elasticHeaderTop
                .autocomplete({
                    source: function(request, response) {
                        var role = $("#selectedSearchSection").text();
                        if (role == "All") {
                            role = "";
                        }

                        $.get(
                            "/api/user/search?query=" +
                                request.term +
                                "&role=" +
                                role,
                            function(data) {
                                console.log(data);
                                response(data.result);
                            }
                        ).fail((error) => {
                            console.log(error);
                            if (error.status === 401) {
                                $("#modal-popup").modal("show");
                            }
                        });
                    },
                    open: function() {
                        //                $(this).autocomplete('widget').css('position', 'fixed');
                        return false;
                    },
                    minLength: 2,
                    select: function(event, ui) {
                        if (ui.item.role == "Lead") {
                            window.location.href = "/lead/" + ui.item.leadCode;
                        } else if (ui.item.role == "Member") {
                            window.location.href =
                                "/member/" + ui.item.userCode;
                        } else if (ui.item.role == "Staff") {
                            window.location.href = "/staff/" + ui.item.userCode;
                        }
                    },
                    close: function(event, ui) {
                        $(this).removeClass("in");
                    },
                    appendTo: ".traqadeSearch",
                })
                .data("ui-autocomplete")._renderItem = function(ul, item) {
                return $("<li></li>")
                    .data("item.autocomplete", item)
                    .append(
                        "<a>" +
                            item.name +
                            "<span class='searchDetailType'>" +
                            item.role +
                            "</span>" +
                            "</a>"
                    )
                    .addClass(item.role)
                    .appendTo(ul);
            };

            elasticHeaderTop
                .on("shown.bs.collapse", function() {
                    $(this).focus();
                })
                .blur(function() {
                    $(this).removeClass("in");
                });
        }
    });
});
